import { isUUID } from '@sigmasms/commons'

import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'eventsHistoryDialog',

  mixins: [ proxy() ],

  props: {
    entityId: {
      type: String,
      required: true,
      validator: isUUID
    }
  },

  render
}
